
export const Error = () => {
    return (
        <div>Whoops! This page does not exist</div>
    );
}

export default Error;